export default __webpack_public_path__ + "static/media/icon-camera.59912c08.svg";